import { createAction, createReducer } from '@reduxjs/toolkit';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { loadLocale } from '@helsenorge/core-utils/date-fns-utils';
import { getUserLanguage, setDocumentLanguage } from '../hn-language';
import { debug, warn } from '../logger';
export const selectCurrentLanguage = (state) => state.currentLanguage;
export const selectLanguages = (state) => state.allowedLanguages;
export const languageChanged = createAction('language/languageChanged');
export const allowedLanguagesReplaced = createAction('language/allowedLanguagesReplaced');
/**
 * Load date-fns locale for the most commonly used languages
 * @param language Language to load date-fns locale for

 */
export const safeLoadLocale = (language) => {
    if (language === LanguageLocales.NORWEGIAN ||
        language === LanguageLocales.NORWEGIAN_NYNORSK ||
        language === LanguageLocales.ENGLISH ||
        language === LanguageLocales.SAMI_NORTHERN) {
        loadLocale(language);
    }
    else {
        debug(`Language changed to ${language}. You need to load the correct date-fns locale yourself and call setDefaultOptions.`);
    }
};
export const createLanguageReducer = (allowedLanguages = [LanguageLocales.NORWEGIAN]) => {
    const userLanguage = getUserLanguage();
    const initialCurrentLanguage = userLanguage && allowedLanguages.includes(userLanguage) ? userLanguage : allowedLanguages[0];
    const initialState = {
        allowedLanguages,
        currentLanguage: initialCurrentLanguage,
    };
    safeLoadLocale(initialCurrentLanguage);
    setDocumentLanguage(initialCurrentLanguage);
    return createReducer(initialState, builder => {
        builder.addCase(languageChanged, (state, action) => {
            if (state.allowedLanguages.includes(action.payload)) {
                state.currentLanguage = action.payload;
                safeLoadLocale(action.payload);
                setDocumentLanguage(action.payload);
            }
            else {
                warn(`${action.payload} is not a valid language for this service. ` +
                    `Supported: ${allowedLanguages.join(', ')}. Source: ${import.meta.url}`);
            }
        });
        builder.addCase(allowedLanguagesReplaced, (state, action) => {
            state.allowedLanguages = action.payload;
            const userLanguage = getUserLanguage();
            // 1. Brukerens foretrukne språk har blitt tilgjengelig, bytt til dette språket
            if (userLanguage && userLanguage !== state.currentLanguage && action.payload.includes(userLanguage)) {
                state.currentLanguage = userLanguage;
                safeLoadLocale(userLanguage);
                setDocumentLanguage(userLanguage);
            }
            // 2. Nåværende språk er ikke lenger tilgjengelig, bytt til første tilgjengelige språk
            else if (!action.payload.includes(state.currentLanguage)) {
                const newLanguage = action.payload[0];
                state.currentLanguage = newLanguage;
                safeLoadLocale(newLanguage);
                setDocumentLanguage(newLanguage);
            }
        });
    });
};
